<script>
  import TextInput from '../../components/TextInput.svelte'
  import Button from '../../components/Button.svelte'
  import { request } from '../../helpers/api'
  import { clientStore, snackBarStore, userStore } from '../../state/store'
  import { t } from '../../i18n/i18n'
  import { notEmpty, isValidEmail } from '../../helpers/form-validation.js'

  const form = {
    name: '',
    contact_name: '',
    phone_number: '',
    email: ''
  }

  $: formValid = notEmpty(form.name) &&
                  isValidEmail(form.email) &&
                  notEmpty(form.phone_number)

  const submitForm = async () => {
    try {
      // Submit form data
      const clientData = await request({
        url: '/api/clients',
        method: 'POST',
        body: JSON.stringify({
          ...form,
          tenant: $userStore.tenant_id
        })
      })
      // Add newly created client to the store
      clientStore.update((clients) => {
        return [
          ...clients,
          clientData
        ]
      })
      snackBarStore.set({ message: $t['Client Added'], type: 'success' })
    } catch (error) {
      snackBarStore.set({ message: $t.something_wrong, type: 'error' })
    }
  }

</script>

  <form on:submit|preventDefault={submitForm}>
    <TextInput
      id='name'
      label='{$t['Client Name']}'
      validityMessage='{$t['Please enter a Client name']}'
      on:input={event => (form.name = event.target.value)}
      value="{form.name}" />
    <TextInput
      id='contact_name'
      label='{$t.contact_name}'
      validityMessage='{$t['Please enter a contact name']}'
      on:input={event => (form.contact_name = event.target.value)}
      value={form.contact_name} />
    <TextInput
      id='phone'
      label='{$t['phone']}'
      validityMessage='{$t['Please enter a phone number']}'
      on:input={event => (form.phone_number = event.target.value)}
      value={form.phone_number}
      type='tel' />
    <TextInput
      id='email'
      label='{$t.email}'
      validityMessage='{$t.valid_email}'
      on:input={event => (form.email = event.target.value)}
      value={form.email} />

    <Button size='full' type="submit" disabled={!formValid}>
      {$t.add_client}
    </Button>
  </form>
